import { Wallets } from './enums/wallets.enum';
import importedWibbtc from './abis/wibbtc.json';
import importedERC20 from './abis/ERC20.json';
import importedIbbtc from './abis/ibbtc.json';
import { AbiItem, toTwosComplement } from 'web3-utils';

export const BLOCKNATIVE_API_KEY = 'd06db039-fbfd-4747-8815-6169b279e391';
export const PORTIS_APP_ID = 'cbf7534d-170d-4903-943f-e607dc588b7f';
export const APP_NAME = 'Badger Wrapped ibBTC';
export const CONTACT_EMAIL = 'hello@badger.finance';

export const BADGER_API = 'https://api.badger.com/v2';

export const RPC_WALLETS: { [index: string]: boolean } = {
	[Wallets.Ledger]: true,
	[Wallets.WalletConnect]: true,
	[Wallets.WalletLink]: true,
	[Wallets.Trezor]: true,
	[Wallets.Portis]: true,
	[Wallets.CoinbaseWallet]: true
};

export const MAX = toTwosComplement(-1);

export const ERC20_ABI = importedERC20.abi as AbiItem[];

export const ONE_MIN_MS = 60 * 1000;

export const WIBBTC_ABI = importedWibbtc.abi as AbiItem[];
export const IBBTC_ABI = importedIbbtc.abi as AbiItem[];

export const WIBBTC = '0x8751D4196027d4e6DA63716fA7786B5174F04C15';
export const IBBTC = '0xc4E15973E6fF2A35cC804c2CF9D2a1b817a8b40F';
export const ZERO_ADDR = '0x0000000000000000000000000000000000000000';
